/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PasswordVerifyAttestationData } from './PasswordVerifyAttestationData';
import {
    PasswordVerifyAttestationDataFromJSON,
    PasswordVerifyAttestationDataFromJSONTyped,
    PasswordVerifyAttestationDataToJSON,
    PasswordVerifyAttestationDataToJSONTyped,
} from './PasswordVerifyAttestationData';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface PasswordVerifyAttestation
 */
export interface PasswordVerifyAttestation {
    /**
     * 
     * @type {string}
     * @memberof PasswordVerifyAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof PasswordVerifyAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {PasswordVerifyAttestationData}
     * @memberof PasswordVerifyAttestation
     */
    data?: PasswordVerifyAttestationData;
}



/**
 * Check if a given object implements the PasswordVerifyAttestation interface.
 */
export function instanceOfPasswordVerifyAttestation(value: object): value is PasswordVerifyAttestation {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function PasswordVerifyAttestationFromJSON(json: any): PasswordVerifyAttestation {
    return PasswordVerifyAttestationFromJSONTyped(json, false);
}

export function PasswordVerifyAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordVerifyAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': json['data'] == null ? undefined : PasswordVerifyAttestationDataFromJSON(json['data']),
    };
}

export function PasswordVerifyAttestationToJSON(json: any): PasswordVerifyAttestation {
    return PasswordVerifyAttestationToJSONTyped(json, false);
}

export function PasswordVerifyAttestationToJSONTyped(value?: PasswordVerifyAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
        'data': PasswordVerifyAttestationDataToJSON(value['data']),
    };
}

